import { Chart } from "primereact/chart";
import { IWorkload } from "../../../../../models/faculty/facultyWorkload";
import { useEffect, useState } from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

const WorkloadViewLarge = (props: IWorkload) => {
  const { setShowWorkload, workload, events } = props;
  const [chartData, setChartData] = useState({});

  const Open = "#f2b53a";
  const InProgress = "#da7a1e";
  const OnHold = "#ff6501";
  const Completed = "#cc5200";
  const Due = "#956813";
  const Events = "#7c4a0f";

  const workloadColors = [Open, InProgress, OnHold, Completed, Due, Events];

  const onClose = () => {
    setShowWorkload(false);
  };

  useEffect(() => {
    if (workload || events) {
      const today = moment().format("YYYY-MM-DD");
      const todayEvents = events.filter(
        (event) => moment(event.start.dateTime).format("YYYY-MM-DD") === today
      );
      const calendarEventsCount =
        todayEvents.length < 1 ? null : todayEvents.length;
      setChartData({
        labels: [
          "Open",
          "In Progress",
          "On Hold",
          "Completed",
          "Due",
          "Events",
        ],
        datasets: [
          {
            data: [
              workload?.open || null,
              workload?.inProgress || null,
              workload?.onHold || null,
              workload?.completed || null,
              workload?.due || null,
              calendarEventsCount,
            ],
            backgroundColor: workloadColors,
          },
        ],
      });
    }
  }, [workload, events]);

  const options = {
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "rect",
          padding: 20,
          boxWidth: 35,
          font: {
            size: 16,
          },
        },
        onClick: () => {},
      },
      datalabels: {
        align: "center",
        color: "white",
        font: {
          weight: "bold",
          size: 14,
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.label;
          },
          title: function () {
            return "";
          },
        },
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        displayColors: false,
        position: "average",
        caretPadding: 20,
        yAlign: "bottom",
      },
    },
    elements: {
      arc: {
        borderWidth: 0.6,
        borderColor: "white",
        borderRadius: 3,
      },
    },
  };

  return (
    <>
      {workload && (
        <>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
              Workload
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="ms-auto">
              <div className="gardedistribution card border-0">
                <Chart
                  type="doughnut"
                  data={chartData}
                  options={options}
                  className=""
                  width="275"
                  plugins={[ChartDataLabels]}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default WorkloadViewLarge;
